import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get ASYNC_COMPONENT() {
    return () => import('@/vue/pages/admin/index_checker/usage/index.vue')
  }
}
